var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade", appear: "" } }, [
    _vm.show
      ? _c(
          "div",
          { staticClass: "award-modal", attrs: { "data-cy": "awards-notice" } },
          [
            _c("div", {
              staticClass: "mask",
              on: {
                click: function($event) {
                  return _vm.$emit("close")
                }
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "body" }, [
              _c(
                "div",
                { staticClass: "header" },
                [
                  _c("img", {
                    staticClass: "bg",
                    attrs: {
                      src: require("@/assets/img/awards/award-modal-bg.jpeg"),
                      alt: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("c-button", {
                    staticClass: "close",
                    attrs: {
                      size: "lg",
                      icon: "cross",
                      ghost: "",
                      "data-cy": "close-awards-notice"
                    },
                    on: {
                      click: function($event) {
                        return _vm.$emit("close")
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "award" }, [
                _c("img", {
                  attrs: {
                    src: require("@/assets/img/awards/award-img.png"),
                    alt: ""
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "content" }, [
                  _c("div", { staticClass: "text" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/img/awards/magic_button.png"),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("h4", [_vm._v("Premio")])
                  ]),
                  _vm._v(" "),
                  _c("h2", { staticClass: "value" }, [
                    _vm._v(
                      "\n            " + _vm._s(_vm.awardValue) + "\n          "
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "content" },
                [
                  _c("h1", { staticClass: "title" }, [
                    _vm._v(
                      "\n          " + _vm._s(_vm.notice.name) + "\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "subtitle" }, [
                    _vm._v(
                      "\n          " + _vm._s(_vm.notice.message) + "\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "author" }, [
                    _vm._v("\n          Concendido por: "),
                    _c("span", [_vm._v(_vm._s(_vm.notice.provided_by))])
                  ]),
                  _vm._v(" "),
                  _c(
                    "k-button",
                    {
                      staticClass: "round-kbutton",
                      attrs: { type: "small" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.clickButton.apply(null, arguments)
                        }
                      }
                    },
                    [_vm._v("\n          Saiba mais\n        ")]
                  )
                ],
                1
              )
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b87a018", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b87a018","hasScoped":false,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Notices/AwardModal.vue
// module id = 2150
// module chunks = 1610